module.exports = __webpack_public_path__ + "static/media/icon-remove.21883fd8.svg";